import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  signal,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { QuotePdfOption, QuoteType } from '../quote-types';

export interface QuotePdfTypeModalData {
  options: QuotePdfOption[];
}

@Component({
  selector: 'app-quote-pdf-type-modal',
  standalone: true,
  imports: [MatRadioModule, MatIcon],
  templateUrl: './quote-pdf-type-modal.component.html',
  styleUrl: './quote-pdf-type-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuotePdfTypeModalComponent {
  private readonly dialogRef = inject(
    MatDialogRef<QuotePdfTypeModalComponent, QuoteType | null>,
  );

  readonly data: QuotePdfTypeModalData = inject(MAT_DIALOG_DATA);

  readonly selectedType = signal<QuoteType | null>(null);
  readonly options = computed(() => this.data.options ?? []);
  readonly canConfirm = computed(() => !!this.selectedType());

  onSelect(type: QuoteType): void {
    this.selectedType.set(type);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onConfirm(): void {
    if (!this.selectedType()) {
      return;
    }
    this.dialogRef.close(this.selectedType());
  }
}
